/**
 * ⚡ РЕШЕНИЕ ВЛАДЕЛЬЦА 10.09.2026 (подтверждено 13.10.2026 при ребрендинге): тёмной темы в проекте
 * НЕТ, только светлая.
 *
 * ⚠️ Из этого следует неочевидное требование. Внутри Telegram при тёмном клиенте themeParams
 * приходят ТЁМНЫМИ, и скрипт telegram-web-app.js сам пишет их в CSS-переменные на <html>.
 * Поэтому палитра Telegram игнорируется ЦЕЛИКОМ: цвета живут только в theme/tokens.css,
 * переменные темы Telegram стили не читают, а шапка, фон и нижняя панель клиента красятся
 * в наши цвета готовыми HEX-строками. Ключи вида 'bg_color' не годятся: ключ берёт цвет из
 * темы клиента, и при тёмном Telegram он тёмный.
 *
 * [G-A3] остаётся в силе в своей главной части: тему красим ВСЕГДА, а не только внутри Telegram.
 * Конструкция `if (!tg) return` перед применением темы — по-прежнему дефект.
 *
 * До ребрендинга здесь же дотягивался контраст подписей Telegram (theme/contrast.ts): теперь
 * контраст обеспечен палитрой и проверен скриптом (02-color.md, раздел 3), а тест палитры —
 * test/palette.test.ts.
 */
import { callTelegram } from '../telegram/call.js'

/**
 * Цвета хрома Telegram. Значения совпадают с токенами theme/tokens.css — менять вместе
 * (test/palette.test.ts это сверяет). Версии Bot API — по changelog Telegram; старый
 * клиент неизвестный метод просто пропустит.
 */
export const TG_COLORS = {
  header: '#F5F4F0',      // --wb-bg        → WebApp.setHeaderColor (HEX — с Bot API 6.9)
  background: '#F5F4F0',  // --wb-bg        → WebApp.setBackgroundColor (6.1)
  bottomBar: '#FFFFFF',   // --wb-tabbar-bg → WebApp.setBottomBarColor (7.10), стык с нашим таббаром
} as const

/** Тема в проекте одна. Функция оставлена, чтобы вызывающий код не гадал. */
export function isDarkNow(): boolean {
  return false
}

export function applyTheme(): void {
  document.documentElement.setAttribute('data-theme', 'light')

  // Шапку, фон и нижнюю панель клиента красим в бумагу и лист — иначе на тёмном Telegram
  // стык приложения и хрома виден полосой. Каждый вызов — отдельно: отказ одного метода
  // на старом клиенте не должен отменять остальные.
  callTelegram((tg) => { tg.setHeaderColor?.(TG_COLORS.header) }, () => { /* вне Telegram шапки нет */ })
  callTelegram((tg) => { tg.setBackgroundColor?.(TG_COLORS.background) }, () => { /* вне Telegram фона нет */ })
  callTelegram((tg) => { tg.setBottomBarColor?.(TG_COLORS.bottomBar) }, () => { /* вне Telegram панели нет */ })
}

/**
 * Подписки на смену схемы нет: следовать не за чем, тема одна.
 * Но красим по-прежнему ВСЕГДА — это и есть суть [G-A3].
 */
export function watchTheme(): () => void {
  applyTheme()
  return () => { /* отписываться не от чего */ }
}
